import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { HomeComponent } from './main-application/home/home.component';
import { TableComponent } from './main-application/table/table.component';
import { AuthGuard } from './_helpers';
import { AppComponent } from './app.component';
import { SettingsComponent } from './main-application/settings/settings.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { QuotesTableComponent } from './main-application/quotes-table/quotes-table.component';
import { RefreshComponent } from './refresh/refresh.component';
import { ProductComponent } from './main-application/product/product.component';
import { CreateProductComponent } from './main-application/create-product/create-product.component';
import { GenerateQuoteComponent } from './main-application/generate-quote/generate-quote.component';
import { CartComponent } from './main-application/cart/cart.component';
import { ProfileComponent } from './main-application/profile/profile.component';
import { AddArtworkComponent } from './main-application/add-artwork/add-artwork.component';
import { QuoteAdminTableComponent } from './main-application/quote-admin-table/quote-admin-table.component';
import { ViewArtworkComponent } from './main-application/view-artwork/view-artwork.component';
import { CustomersTableComponent } from './main-application/customers-table/customers-table.component';
import { SetPasswordComponent } from './auth/set-password/set-password/set-password.component';
import { NavigationComponent } from './navigation/navigation.component';
import { BulkOrdersComponent } from './main-application/bulk-orders/bulk-orders.component';
import { ViewBulkOrdersComponent } from './main-application/bulk-orders/view-bulk-orders/view-bulk-orders/view-bulk-orders.component';
import { ReviewBulkOrdersComponent } from './main-application/bulk-orders/review-bulk-orders/review-bulk-orders.component';
import { SwitchWebhookComponent } from './main-application/switch-webhook/switch-webhook.component';
import { SwitchWebhookClientComponent } from './main-application/switch-webhook/switch-webhook-client/switch-webhook-client.component';
import { SwitchWebhookAdminComponent } from './main-application/switch-webhook/switch-webhook-admin/switch-webhook-admin.component';
import { RejectedBulkOrdersComponent } from './main-application/bulk-orders/rejected-bulk-orders/rejected-bulk-orders.component';
import { AdminBulkordersComponent } from './main-application/settings/admin-bulkorders/admin-bulkorders.component';
import { AdminSwitchComponent } from './main-application/settings/admin-switch/admin-switch.component';
import { CreateOrderTypeComponent } from './main-application/bulk-orders/create-order-type/create-order-type.component';
import { AdminDashboardComponent } from './main-application/clinic-management/admin-dashboard/admin-dashboard.component';
import { NurseDashboardComponent } from './main-application/clinic-management/nurse-dashboard/nurse-dashboard.component';
import { ClinicCartComponent } from './main-application/cart/clinic-cart/clinic-cart.component';
import { ClinicProductsComponent } from './main-application/clinic-management/clinic-products/clinic-products.component';
import { SalesOrdersComponent } from './main-application/clinic-management/sales-orders/sales-orders.component';
import { ClinicOrdersComponent } from './main-application/clinic-management/clinic-orders/clinic-orders.component';
import { NurseDetailsComponent } from './main-application/clinic-management/nurse-details/nurse-details.component';
import { CreditViewComponent } from './main-application/clinic-management/credit-view/credit-view.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: {
      role: ['admin', 'customer-zpl', 'customer-pifsa', 'review-bulkorders'],
    },
  },
  {
    path: 'createproduct',
    component: CreateProductComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin'] },
  },
  {
    path: 'product',
    component: ProductComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin'] },
  },
  { path: 'refresh', component: RefreshComponent },
  {
    path: 'viewmyquotes',
    component: QuotesTableComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'customer-zpl'] },
  },
  {
    path: 'generatequote',
    component: GenerateQuoteComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'customer-zpl'] },
  },
  {
    path: 'profile',
    component: ProfileComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'customer-zpl', 'customer-pifsa'] },
  },
  {
    path: 'cart',
    component: CartComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'customer-zpl', 'customer-pifsa'] },
  },
  {
    path: 'clinic-cart',
    component: ClinicCartComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['clinic-admin', 'hq-clinic-admin'] },
  },

  {
    path: 'artwork',
    component: AddArtworkComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'customer-pifsa'] },
  },
  {
    path: 'quote-admin-table',
    component: QuoteAdminTableComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin'] },
  },
  {
    path: 'view-artwork',
    component: ViewArtworkComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'customer-pifsa'] },
  },
  {
    path: 'customer-table',
    component: CustomersTableComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin'] },
  },
  {
    path: 'bulk-orders',
    component: BulkOrdersComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'basic-bulkorders', 'admin-bulkorders'] },
  },
  {
    path: 'view-bulk-orders',
    component: ViewBulkOrdersComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'review-bulkorders', 'admin-bulkorders'] },
  },
  {
    path: 'review-bulk-orders',
    component: ReviewBulkOrdersComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'review-bulkorders', 'admin-bulkorders'] },
  },
  {
    path: 'rejected-bulk-orders',
    component: RejectedBulkOrdersComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'review-bulkorders', 'admin-bulkorders'] },
  },
  {
    path: 'switch-webhook',
    component: SwitchWebhookComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'customer-switch', 'admin-switch'] },
  },
  {
    path: 'switch-webhook-client',
    component: SwitchWebhookClientComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'customer-switch'] },
  },
  {
    path: 'switch-webhook-admin',
    component: SwitchWebhookAdminComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'admin-switch'] },
  },
  {
    path: 'admin-bulkorders',
    component: AdminBulkordersComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['review-bulkorders'] },
  },
  {
    path: 'switch-admin',
    component: AdminSwitchComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin-switch'] },
  },
  {
    path: 'view-bulk-orders',
    component: ViewBulkOrdersComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'admin-bulkorders'] },
  },
  {
    path: 'admin-dashboard',
    component: AdminDashboardComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: {
      role: ['admin', 'hq-clinic-admin', 'hq-clinic-user', 'zpl-clinic-admin'],
    },
  },
  {
    path: 'my-clinics',
    component: NurseDashboardComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['clinic-admin'] },
  },
  {
    path: 'settings',
    component: SettingsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'customer-zpl', 'customer-pifsa'] },
  },
  {
    path: 'create-order-type',
    component: CreateOrderTypeComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'admin-bulkorders'] },
  },
  {
    path: 'clinic-products',
    component: ClinicProductsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['admin', 'hq-clinic-admin', 'zpl-clinic-admin'] },
  },
  {
    path: 'sales-order',
    component: SalesOrdersComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: {
      role: [
        'admin',
        'hq-clinic-admin',
        'clinic-admin',
        'hq-clinic-user',
        'zpl-clinic-admin',
      ],
    },
  },
  {
    path: 'clinic-orders',
    component: ClinicOrdersComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['clinic-admin'] },
  },
  {
    path: 'credit-view',
    component: CreditViewComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['clinic-admin'] },
  },
  {
    path: 'nurse-details',
    component: NurseDetailsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { role: ['clinic-admin'] },
  },
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'set-password', component: SetPasswordComponent },
  { path: 'logout', component: LoginComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
